module.exports = __webpack_public_path__ + "media/images/logo-obn-310af7cc99d9cc7648e33e27fb1bbf02.png";